const MVP_VISIBLE_NAV_PATHS = new Set([
  '/dashboard',
  '/appointments',
  '/patients',
  '/billing',
  '/offers',
  '/loyalty',
  '/pos',
  '/staff-operations',
  '/timesheets',
  '/mobile-capture',
  '/inventory',
  '/marketing',
  '/audit/activity',
  '/reports/operations',
  '/settings',
]);

const MVP_VISIBLE_SETTINGS_PATHS = new Set([
  '/settings/profile',
  '/settings/locations',
  '/settings/users',
  '/settings/roles',
  '/settings/providers',
  '/settings/appointmenttypes',
  '/settings/resources',
  '/settings/practice-users',
  '/settings/schedule-assets',
  '/settings/room-management',
  '/settings/scheduling',
  '/settings/telemed',
  '/settings/manual-tests',
  '/settings/document-types',
  '/settings/billing-catalog',
  '/settings/payments',
  '/settings/inventory',
  '/settings/medical-forms',
  '/settings/charts',
  '/settings/external-users',
  '/settings/treatment-plans',
  '/settings/account',
]);

const MVP_VISIBLE_DASHBOARD_WIDGET_IDS = new Set([
  'providerDayDispatch',
  'revenue',
  'activePatients',
  'noShow',
  'apptVolume',
]);

export function filterMvpNavItems<T extends { path: string }>(items: T[]): T[] {
  return items.filter((item) => MVP_VISIBLE_NAV_PATHS.has(item.path));
}

export function filterMvpSettingsCards<T extends { path: string }>(items: T[]): T[] {
  return items.filter((item) => MVP_VISIBLE_SETTINGS_PATHS.has(item.path));
}

export function filterMvpDashboardWidgets<T extends { id: string }>(items: T[]): T[] {
  return items.filter((item) => MVP_VISIBLE_DASHBOARD_WIDGET_IDS.has(item.id));
}
